import Client from './client';

export default {
  settings: () => Client.get('/settings'),
}
